export class Login {
    public username: string;
    public password: string;
    public exportCompanyid: number;
}


// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/model/login-model.ts